import React from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';

import InfoPopover from '../InfoPopover/InfoPopover';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';

import s from './ChartIntroLabel.module.scss';

const ChartIntroLabel = (props) => {
  const { theme, title, description, titleId, infoTitle, infoText, infoLink, popoverTheme, modifiers  } =
    props;

  const [inViewRef, isVisible] = useIntersectionObserver(0.5, undefined, true);

  const hasInfo = !!infoTitle && !!infoText;

  const color = theme === 'dark' ? 'black' : 'white';
  const rootCls = classNames(s.Root, {
      [s.Visible]: isVisible,
      [s.Dark]: theme === 'dark',
    },
    modifiers.map((m) => s[m])
  );

  return (
    <div ref={inViewRef} className={rootCls}>
      <div className={s.TitleWrapper} id={titleId}>
        <h4 className={s.Title}>{title}</h4>
        {hasInfo && (
          <div className={`${s.Desktop}`}>
            <InfoPopover
              color={color}
              title={infoTitle}
              text={infoText}
              link={infoLink}
              {...popoverTheme}
            />
          </div>
        )}
      </div>
      <p className={s.Description}>{description}</p>
      <div className={`${s.InfoWrapper} ${s.Responsive}`}>
        {hasInfo && (
          <InfoPopover
            color={color}
            title={infoTitle}
            text={infoText}
            link={infoLink}
            {...popoverTheme}
          />
        )}
      </div>
    </div>
  );
};

ChartIntroLabel.propTypes = {
  titleId: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  title: PropTypes.string,
  description: PropTypes.string,
  infoTitle: PropTypes.string,
  infoText: PropTypes.string,
  infoLink: PropTypes.shape({
    href: PropTypes.string,
    text: PropTypes.string,
  }),
  popoverTheme: PropTypes.shape({
    background: PropTypes.oneOf(['black-glass', 'white-glass']),
  }),
  modifiers: PropTypes.array,
};

ChartIntroLabel.defaultProps = {
  theme: 'dark',
  title: '',
  description: '',
  popoverTheme: {
    background: 'black-glass',
  },
  modifiers: [],
};

export default ChartIntroLabel;
